import { addMessages } from '@hana/i18n';

// Khoá chuỗi chung nhỏ của Mee (Công & phép, Phát triển, Chấm công tháng, trạng thái, Parts). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'mc.workLeave': 'Công & phép trong kỳ',
  'mc.workLeaveTip': 'Công chuẩn theo WorkCalendar, công thực tế từ bảng công đã chốt, phép có lương và giờ làm thêm theo đơn đã duyệt.',
  'mc.std': 'Công chuẩn',
  'mc.locked': 'Kỳ đã chốt',
  'mc.actual': 'Công thực tế',
  'mc.paid': 'Phép có lương',
  'mc.otLabel': 'OTNormalHours · theo đơn tăng ca đã duyệt',
  'mc.ot': 'Ngoài giờ',
  'mc.courses': 'Khoá học',
  'mc.mandatory': 'Bắt buộc · quá hạn hoặc sắp hạn',
  'mc.explain': 'Giải trình ngày này',
  'mc.monthMix': 'Cơ cấu tháng',
  'mc.mix': 'Cơ cấu ngày công',
  'mc.hoursByDay': 'Giờ có mặt theo ngày',
  'mc.hours': 'Giờ có mặt',
  'mc.hoursTip': 'Vạch ngang = giờ chuẩn của ngày theo lịch công ty',
  'mc.err': 'Không tải được dữ liệu của tôi',
  'mc.errDesc': 'Mất kết nối lúc 08:42 · lần chấm công tiếp theo được ghi tạm trên máy và gửi lại khi có mạng.',
  'mc.retry': 'Thử lại',
  'mc.noLink': 'Tài khoản chưa liên kết hồ sơ nhân viên',
  'mc.noLinkDesc': 'Tài khoản chưa liên kết hồ sơ nhân sự. Liên hệ HR.',
  'mc.reqSent': 'Đã gửi yêu cầu liên kết tới [HRD-MGR] HANHLTM',
  'mc.reqHr': 'Gửi yêu cầu tới HR',
  'mc.daysLeft': 'ngày còn',
  'mc.ezyDetail': 'Chi tiết ở HANA Ezy ↗',
  'mc.openEdu': 'Mở HANA Edu ↗',
  'mc.pdf': 'Tải PDF',
  'mc.pdfToast': 'Đang tải phiếu lương {p} · PDF vector, có mật khẩu',
});
addMessages('en', {
  'mc.workLeave': 'Work & leave in period',
  'mc.workLeaveTip': 'Standard days per WorkCalendar, actual days from the locked timesheet, paid leave and overtime per approved requests.',
  'mc.std': 'Standard days',
  'mc.locked': 'Period locked',
  'mc.actual': 'Actual days',
  'mc.paid': 'Paid leave',
  'mc.otLabel': 'OTNormalHours · per approved overtime requests',
  'mc.ot': 'Overtime',
  'mc.courses': 'Courses',
  'mc.mandatory': 'Mandatory · overdue or due soon',
  'mc.explain': 'Explain this day',
  'mc.monthMix': 'Month breakdown',
  'mc.mix': 'Work-day breakdown',
  'mc.hoursByDay': 'Hours present by day',
  'mc.hours': 'Hours present',
  'mc.hoursTip': 'Horizontal line = standard hours of the day per company calendar',
  'mc.err': 'Could not load my data',
  'mc.errDesc': 'Connection lost at 08:42 · the next check-in is saved on the device and resent when online.',
  'mc.retry': 'Retry',
  'mc.noLink': 'Account is not linked to an employee record',
  'mc.noLinkDesc': 'Account is not linked to an HR record. Contact HR.',
  'mc.reqSent': 'Link request sent to [HRD-MGR] HANHLTM',
  'mc.reqHr': 'Send request to HR',
  'mc.daysLeft': 'days left',
  'mc.ezyDetail': 'Details in HANA Ezy ↗',
  'mc.openEdu': 'Open HANA Edu ↗',
  'mc.pdf': 'Download PDF',
  'mc.pdfToast': 'Downloading payslip {p} · vector PDF, password-protected',
});
